import React, { ChangeEvent, useContext, useEffect, useState } from "react";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import Typeahead from "../../../shared/Typeahead/Typeahead";
import ILot from "../../../../models/ILot";
import OwButton from "../../../shared/OwButton/OwButton";
import OwTable from "../../../shared/OwTable/OwTable";
import IOrder_ItemUI from "../../../../models/IOrder_ItemUI";
import IPacking_List from "../../../../models/IPacking_List";
import UserContext from "../../../../contexts/UserContext";
import SupplierContext from "../../../../contexts/SupplierContext";
import IOwTableCols from "../../../../models/IOwTableCols";
import UserService from "../../../../services/UserService";
import ILotUI from "../../../../models/ILotUI";
import _ from "lodash";
import OwInputWrapper from "../../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import IGetLotsDTO from "../../../../models/DTO/IGetLotsDTO";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import IOnGetLotsDTO from "../../../../models/DTO/IOnGetLotsDTO";
import { SocketContext } from "../../../../contexts/SocketContext";
import IUiSocketSetup from "../../../../models/IUiSocketSetup";
import CreateLotSidebar from "../../../lots/CreateLotSidebar/CreateLotSidebar";
import IOnProcessLotDTO from "../../../../models/DTO/IOnProcessLotDTO";
import UiContext from "../../../../contexts/UiContext";

type Props = {
    packingList: IPacking_List;
    row: IOrder_ItemUI;
    parentRowIndex: number;
    orderItems: IOrder_ItemUI[];
    handleQtyChange: (e: ChangeEvent<any>, lot: ILotUI, parentRowIndex: number) => void;
    addLot: (row: IOrder_ItemUI, selectedLots: { [key: string]: ILot | null }) => void;
    deleteLot: (lot: ILotUI, parentRowIndex: number) => void;
};

export const PackingListDetailLotsDetailView = (props: Props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const socket = useContext(SocketContext)!;
    const uiContext = useContext(UiContext);

    const selectedItem = null;

    const [foundLots, setFoundLots] = useState<{ [key: string]: ILot[] }>({});
    const [selectedLots, setSelectedLots] = useState<{ [key: string]: ILot | null }>({});

    const [clearTypeahead, setClearTypeahead] = useState<boolean>(false);

    const clearTypeaheadFn = (row: IOrder_ItemUI) => {
        const _selectedLots = {
            ...selectedLots,
        };

        _selectedLots[row.guid] = null;

        setClearTypeahead(false);
        setSelectedLots(_selectedLots);
    };

    const selectLot = (lot: ILot, row: IOrder_ItemUI) => {
        const _selectedLots = {
            ...selectedLots,
        };

        _selectedLots[row.guid] = lot;

        setSelectedLots(_selectedLots);
    };

    const getLots = (name: string, row: IOrder_ItemUI) => {
        const payload: IGetLotsDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            catalogItemGuid: row.Catalog_Item!.guid,
            queryString: `?name=${name}`,
            limit: 8,
            rowGuid: row.guid,
        };

        socket.emit(EndpointsEnum.CatalogItemGetLots, payload);
    };

    const onGetLots = (data: IOnGetLotsDTO) => {
        const _foundLots = {
            ...foundLots,
        };

        if (data.rowGuid) {
            _foundLots[data.rowGuid] = data.lots;
        }

        setFoundLots(_foundLots);
    };

    const sockets: IUiSocketSetup[] = [{ endpoint: EndpointsEnum.CatalogItemOnGetLots, fn: onGetLots }];

    useEffect(() => {
        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        return () => {
            for (const _socket of sockets) {
                socket.off(_socket.endpoint, _socket.fn);
            }
        };
    }, []);

    const cancelSidebar = (row: IOrder_ItemUI, data: IOnProcessLotDTO | null) => {
        uiContext.setSidebarComponent(null);
        uiContext.toggleSidebar(false);
    };

    const createNewLot = (row: IOrder_ItemUI) => {
        const component = (
            <CreateLotSidebar
                userModel={userModel}
                supplierModel={supplierModel}
                socket={socket}
                cancel={(refresh?: boolean, data?: IOnProcessLotDTO) => {
                    cancelSidebar(row, data!);
                }}
                catalogItemModel={row.Catalog_Item!}
            />
        );

        uiContext.setSidebarComponent(component);
        uiContext.toggleSidebar(true);

        setClearTypeahead(true);
    };

    const renderLotQtyInputFn = (lot: ILotUI, rowIndex: number, isDetailViewTable?: boolean, parentRowIndex?: number) => {
        if (_.isNil(parentRowIndex)) {
            return null;
        }

        const parentOrderItem = props.orderItems[parentRowIndex];

        let orderItemLotQty = 0;

        if (props.packingList) {
            if (props.packingList.Order_Item_Lot_Maps) {
                for (const orderItemLotMap of props.packingList.Order_Item_Lot_Maps) {
                    if (orderItemLotMap.lot_id === lot.id && parentOrderItem.id === orderItemLotMap.order_item_id) {
                        if (!_.isNil(orderItemLotMap.qty)) {
                            orderItemLotQty = orderItemLotMap.qty;
                        } else {
                            orderItemLotQty = 0;
                        }
                    }
                }
            }
        }

        if (props.packingList.is_locked) {
            return <div>{orderItemLotQty}</div>;
        } else {
            return (
                <div>
                    <OwInputWrapper
                        name={"qty"}
                        value={orderItemLotQty}
                        fn={(e: ChangeEvent<any>) => {
                            props.handleQtyChange(e, lot, parentRowIndex);
                        }}
                        type={"number"}
                    />
                </div>
            );
        }
    };

    const renderLotActionColFn = (lot: ILotUI, rowIndex: number, isDetailViewTable?: boolean, parentRowIndex?: number) => {
        // console.log('renderLotActionColFn: ', lot, rowIndex, isDetailViewTable, parentRowIndex);
        if (_.isNil(parentRowIndex) || props.packingList.is_locked) {
            return null;
        }

        return (
            <div className={"d-print-none"}>
                <i
                    className={"fad fa-trash-alt text-danger pointer"}
                    title={"Delete Lot?"}
                    onClick={() => {
                        props.deleteLot(lot, parentRowIndex);
                    }}
                />
            </div>
        );
    };

    const renderLotItems = (lot: ILotUI) => {
        return (
            <div className={"text-center"}>
                <div>{lot.name}</div>
                {lot.exp_date ? (
                    <div className={"text-small d-flex"}>
                        <OwLabel title={"exp"} postText={":"} className={"me-1"} />
                        {UserService.parseDate(lot.exp_date)}
                    </div>
                ) : null}
            </div>
        );
    };

    const getLotTableCols = (): IOwTableCols[] => {
        const cols: IOwTableCols[] = [
            {
                title: "",
                valueProp: "",
                renderFn: renderLotActionColFn,
                renderFnEmitsRow: true,
                isActionsCol: true,
                className: "d-print-none",
            },
            {
                title: "qty",
                valueProp: "qty",
                renderFn: renderLotQtyInputFn,
                renderFnEmitsRow: true,
                className: "w-7r",
            },
            {
                title: "lot",
                valueProp: "name",
            },
        ];

        if (supplierModel.has_exp_date) {
            cols.push({
                title: "exp_date",
                valueProp: "exp_date",
                renderFn: (dateStr: string) => {
                    return UserService.parseDate(dateStr);
                },
            });
        }

        return cols;
    };

    return (
        <div className={"PackingListDetailLotsDetailView"}>
            <div>
                <div className={"d-flex"}>
                    <OwTitle title={"lots"} tag={"h5"} isUnderline={true} />
                </div>
                {props.packingList.is_locked ? null : (
                    <div className={"row d-flex d-print-none"}>
                        <div className={"col-12 col-sm-6 col-md-4 col-lg-3 pe-2"}>
                            <Typeahead
                                isSelectableFn={() => {
                                    return true;
                                }}
                                typeaheadApiFn={(str: string) => {
                                    getLots(str, props.row);
                                }}
                                typeaheadItems={foundLots[props.row.guid]}
                                title={"name"}
                                itemsRenderFn={renderLotItems}
                                selectedItemFn={(lot: ILot) => {
                                    selectLot(lot, props.row);
                                }}
                                selectedItem={selectedLots[props.row.guid]}
                                selectedItemTitleProp={"name"}
                                showCreateNew={true}
                                createNewFn={() => {
                                    createNewLot(props.row);
                                }}
                                clearTypeahead={clearTypeahead}
                                clearTypeaheadCallback={() => {
                                    clearTypeaheadFn(props.row);
                                }}
                            />
                        </div>

                        <div className={"col ps-0"}>
                            <OwButton
                                title={"add"}
                                leftIconClass={"fas fa-plus"}
                                fn={() => {
                                    props.addLot(props.row, selectedLots);
                                }}
                                disabled={!selectedLots[props.row.guid]}
                            />
                        </div>
                    </div>
                )}
                <div className={"mt-2"}>
                    <OwTable
                        columns={getLotTableCols()}
                        dataSet={(props.row.Lots || []).filter((lot) => {
                            return !lot.deleteFlag;
                        })}
                        dataFetch={false}
                        initialData={false}
                        userModel={userModel}
                        supplierModel={supplierModel}
                        isDetailViewTable={true}
                        parentRowIndex={props.parentRowIndex}
                    />
                </div>
            </div>
            );
        </div>
    );
};
